export default {
  "supplierSap": {
    "adminOnly": "仅管理员可执行供应商来源核对与同步",
    "systemInvalid": "SAP供应商来源系统配置无效，请联系管理员",
    "schemaMissing": "供应商同步结构尚未就绪，请完成受控迁移后重试",
    "sourceLimit": "供应商来源超出单次核对范围，请联系管理员缩小范围",
    "previewChanged": "供应商来源或目录已变化，请重新核对后同步",
    "readonly": "供应商基本资料由SAP维护，请在SAP修改后通过SP0230同步"
  }
};
